import {
  CompanyHostDeviceId,
  CompanyName,
  companyHostDeviceId,
  companyName,
} from '@edgvr-front/companies/domain';
import { Validate } from '@edgvr-front/util/validate';

export class CompanyHostDeviceEnableRequestDTO {
  private static validation = Validate.compile(
    CompanyHostDeviceEnableRequestDTO.validationSchema()
  );

  constructor(readonly data: CompanyHostDeviceEnableRequest) {
    Validate.assert(CompanyHostDeviceEnableRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['companyName', 'deviceId'],
      properties: {
        companyName,
        deviceId: companyHostDeviceId,
      },
    };
  }
}

interface CompanyHostDeviceEnableRequest {
  companyName: CompanyName;
  deviceId: CompanyHostDeviceId;
}
